// @ts-ignore
import unicode from "unicode-properties";

import { isValidEmailAddress, mapFilterUndefined, normalizeEmailAddress, truthify } from "./Support";

export function isDigit(c: string): boolean {
    return "0123456789".indexOf(c) >= 0;
}

export function isAlphabetic(c: string): boolean {
    return truthify(unicode.isAlphabetic(c.charCodeAt(0)));
}

export function isAlphanumeric(c: string): boolean {
    return isAlphabetic(c) || isDigit(c);
}

export function isWhitespace(c: string): boolean {
    return truthify(unicode.isWhiteSpace(c.charCodeAt(0)));
}

const digitsRegex = /^([0-9]+)(.*)/;

export function compareStringsSmartly(a: string, b: string): number {
    const aMatch = digitsRegex.exec(a);
    const bMatch = digitsRegex.exec(b);
    if (aMatch !== null && bMatch !== null) {
        const aNum = parseInt(aMatch[1]);
        const bNum = parseInt(bMatch[1]);
        if (aNum !== bNum) {
            return aNum - bNum;
        }

        a = aMatch[2];
        b = bMatch[2];
    }

    a = a.toLocaleLowerCase();
    b = b.toLocaleLowerCase();
    if (a < b) {
        return -1;
    } else if (a > b) {
        return 1;
    } else {
        return 0;
    }
}

export function splitEmailAddresses(str: string): string[] {
    return mapFilterUndefined(str.split(","), e => {
        e = normalizeEmailAddress(e);
        if (!isValidEmailAddress(e)) return undefined;
        return e;
    });
}
